/**
 * RemoveMemberDialog Component
 * 
 * Dialog for confirming removal of a workspace member.
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { WorkspaceMemberWithDetails } from "../../../types";

export interface RemoveMemberDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  memberToRemove: WorkspaceMemberWithDetails | null;
  removing: boolean;
}

export default function RemoveMemberDialog({
  open,
  onClose,
  onConfirm,
  memberToRemove,
  removing,
}: RemoveMemberDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Remove Member</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to remove{" "}
          <strong>{memberToRemove?.email || memberToRemove?.name || "this user"}</strong> from the
          workspace?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2, pt: 1, gap: 1, display: "flex" }}>
        <Button 
          onClick={onClose} 
          disabled={removing}
          variant="outlined"
          sx={{ flex: 1, py: 1.5 }}
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained" 
          disabled={removing}
          sx={{ flex: 1, py: 1.5 }}
        >
          {removing ? "Removing..." : "Remove"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
